import { FC } from 'react'

import { ISvgClass } from '../interface'

const DeleteIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M7 21C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99934 19.5493 5 19V6C4.71667 6 4.479 5.904 4.287 5.712C4.095 5.52 3.99934 5.28267 4 5C4 4.71667 4.096 4.479 4.288 4.287C4.48 4.095 4.71734 3.99934 5 4H9C9 3.71667 9.096 3.479 9.288 3.287C9.48 3.095 9.71734 2.99934 10 3H14C14.2833 3 14.521 3.096 14.713 3.288C14.905 3.48 15.0007 3.71734 15 4H19C19.2833 4 19.521 4.096 19.713 4.288C19.905 4.48 20.0007 4.71734 20 5C20 5.28334 19.904 5.521 19.712 5.713C19.52 5.905 19.2827 6.00067 19 6V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7ZM7 6V19H17V6H7ZM9 16C9 16.2833 9.096 16.521 9.288 16.713C9.48 16.905 9.71734 17.0007 10 17C10.2833 17 10.521 16.904 10.713 16.712C10.905 16.52 11.0007 16.2827 11 16V9C11 8.71667 10.904 8.479 10.712 8.287C10.52 8.095 10.2827 7.99934 10 8C9.71667 8 9.479 8.096 9.287 8.288C9.095 8.48 8.99934 8.71734 9 9V16ZM13 16C13 16.2833 13.096 16.521 13.288 16.713C13.48 16.905 13.7173 17.0007 14 17C14.2833 17 14.521 16.904 14.713 16.712C14.905 16.52 15.0007 16.2827 15 16V9C15 8.71667 14.904 8.479 14.712 8.287C14.52 8.095 14.2827 7.99934 14 8C13.7167 8 13.479 8.096 13.287 8.288C13.095 8.48 12.9993 8.71734 13 9V16Z"
        fill="inherit"
      />
    </svg>
  )
}

export default DeleteIcon
